<template>
    <b-row>
        <b-col
            cols="12"
            class="sensor-icons"
            :class="isDamOrigin ? 'container-wrap': 'd-flex justify-content-between'"
        >
            <template v-if="getDamData && !currentDamError">
                <RightPanelContainerIcon
                    v-for="(iconKey, index) in filteredData"
                    :key="index"
                    :sensor-icon-key="iconKey"
                    :data-data="iconKey"
                    :sensor-name="$i18n.t(`sensors.${iconKey}`) || iconKey"
                    :sensor-data="prepareSensorData(getDamData[iconKey])"
                    :isDamOrigin="isDamOrigin"
                >
                </RightPanelContainerIcon>
            </template>

            <template v-if="currentDamError">
                <div class="text-danger text-center">{{ $t('dashboard.errorMessage') }}</div>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    // utils, vuex
    import {mapGetters} from "vuex";
    // assets
    import {iconsInPanel} from "../../constants/sensors-constants";
    // components
    import RightPanelContainerIcon from "./RightPanelContainerIcon";

    /**
     * Wrapper for the icons.
     * Filters the sensor's data as to show
     * only the icons we need, in the correct order.
     */

    export default {
        name: "RightPanelContainerIcons",
        props: {
            isDamOrigin: Boolean
        },
        components: {
            RightPanelContainerIcon
        },
        data() {
            return {
                iconsInPanel
            }
        },
        computed: {
            ...mapGetters(['getDamData', 'currentDamError']),
            filteredData() {
                const damDataKeys = Object.keys(this.getDamData);

                return this.iconsInPanel
                    .filter(key => damDataKeys.includes(key))
            }
        },
        methods: {
            prepareSensorData(sensorData) {
                if (Array.isArray(sensorData)) {
                    return sensorData[1];
                } else {
                    return sensorData;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";

    .sensor-icons {
        align-items: center;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .container-wrap {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;

        @include media-breakpoint-up(md) {
            grid-template-columns: 1fr 1fr 1fr;
        }

        @include media-breakpoint-up(xl) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }
    }
</style>